import script from "./articleFilter.vue?vue&type=script&lang=js"
export * from "./articleFilter.vue?vue&type=script&lang=js"

import "./articleFilter.vue?vue&type=style&index=0&id=3b194af8&lang=scss"

const __exports__ = script;

export default __exports__